<template>
	<div>
		<div v-if="menu == false">
			<flCabecalhoForm
				:msg="_traducao('global', 'obrigatorio')"
				cls="print-titulo-form-20"
				:texto="_traducao('menuAGnovoUsuario', 'menuAGguarnicao2')"
			/>
			<div class="row no-print form-group">
				<div class="col-md-12">
					<label>{{ _traducao('menuAGnovoUsuario', 'menuAGguarnicao') }}</label>
					<br />

					<div class="btn-group" role="group">
						<button
							type="button"
							@click="esta_guarnicao = 1"
							class="btn btn-sm btn-default"
							:class="{'btn-info': esta_guarnicao == 1}"
						>
							{{ _traducao('menuAGnovoUsuario', 'menuAGsim') }}
						</button>
						<button
							type="button"
							@click="esta_guarnicao = 0"
							class="btn btn-sm btn-default"
							:class="{'btn-info': esta_guarnicao == 0}"
						>
							{{ _traducao('menuAGnovoUsuario', 'menuAGnao') }}
						</button>
					</div>
				</div>
			</div>
			<div v-if="esta_guarnicao == 1">
				<div class="row">
					<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.guarnicao != ''}">
						<label><span class="no-print">* </span>{{ _traducao('menuAGnovoUsuario', 'menuAGtipo') }}:</label>
						<select class="form-control input-sm" v-model="form.guarnicao.guarnicao">
							<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
							<option v-for="item in guarnicoes" :value="item.id" :key="item.id">{{ item.descricao }}</option>
						</select>
						<p class="help-block" v-show="erro.guarnicao != ''">{{ erro.guarnicao }}</p>
					</div>

					<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.tipo_certificado != ''}">
						<label>* Tipo Certificado:</label>
						<select class="form-control input-sm" v-model="form.guarnicao.tipo_certificado">
							<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
							<option value="1">{{ _traducao('menuAGnovoUsuario', 'pClasse') }}</option>
							<option value="2">{{ _traducao('menuAGnovoUsuario', 'sClasse') }}</option>
							<option value="3">{{ _traducao('menuAGnovoUsuario', 'tClasse') }}</option>
						</select>
						<p class="help-block" v-show="erro.tipo_certificado != ''">{{ erro.tipo_certificado }}</p>
					</div>

					<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.validade_exame != ''}">
						<label>* Validade Certificado:</label>
						<flDateTime
							@v-model="(val) => (form.guarnicao.validade_exame = val)"
							:value="form.guarnicao.validade_exame"
							:lang="_getLangDp"
							:format="_formatDate"
							name="validadeexame"
						/>
						<p class="help-block" v-show="erro.validade_exame != ''">{{ erro.validade_exame }}</p>
					</div>

					<div class="col-xs-12 col-md-3 form-group" v-show="menu == false" :class="{'has-error': erro.departamento != ''}">
						<label><span class="no-print">* </span>{{ _traducao('menuAGnovoUsuario', 'menuAGdepto') }}:</label>
						<select class="form-control input-sm" v-model="form.guarnicao.departamento">
							<option v-for="item in departamentos" :value="item.id" :key="item.id">{{ item.descricao }}</option>
						</select>
						<p class="help-block" v-show="erro.departamento != ''">{{ erro.departamento }}</p>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-md-3 form-group" v-show="menu == false" :class="{'has-error': erro.cargo != ''}">
						<label><span class="no-print">* </span>{{ _traducao('menuAGnovoUsuario', 'menuAGcargo') }}:</label>
						<select class="form-control input-sm" v-model="form.guarnicao.cargo">
							<option v-for="item in cargos" :value="item.id" :key="item.id">{{ item.descricao }}</option>
						</select>
						<p class="help-block" v-show="erro.cargo != ''">{{ erro.cargo }}</p>
					</div>
				</div>
			</div>
		</div>

		<flCabecalhoForm :msg="_traducao('global', 'obrigatorio')" cls="print-titulo-form-20" :texto="'Dados Adicionais'" />
		<div class="row">
			<div class="col-xs-12 form-group">
				<label> {{ _traducao('global', 'adicionar') }} :</label><br />
				<div class="btn-group">
					<button
						class="btn btn-sm btn-default"
						@click="form._controleAdicional = true"
						:class="{'btn-info': form._controleAdicional}"
					>
						Sim
					</button>
					<button
						class="btn btn-sm btn-default"
						@click="form._controleAdicional = false"
						:class="{'btn-info': !form._controleAdicional}"
					>
						Não
					</button>
				</div>
			</div>
		</div>
		<div v-if="form._controleAdicional">
			<fl-dados-adicionais
				ref="dados_adicionais"
				@dados-adicionais="
					(item) => {
						form.dados_adicionais = item
					}
				"
				:postos="postos"
				:cargos="cargos"
				:menu="menu"
			/>
			<flCabecalhoForm :msg="_traducao('global', 'obrigatorio')" cls="print-titulo-form-20" :texto="'Endereço'" />
			<fl-endereco
				tipo="residencial"
				ref="endereco_residencial"
				@dados-endereco-residencial="
					(item) => {
						form.dados_endereco_residencial = item
					}
				"
			/>
		</div>
	</div>
</template>
<script>
import flDadosAdicionais from './dados-adicionais.vue'
import flEndereco from '../../../../../components/endereco/main.vue'
export default {
	props: ['menu', 'cargos', 'guarnicoes', 'postos'],
	components: {flDadosAdicionais, flEndereco},
	data() {
		return {
			departamentos: [],
			esta_guarnicao: 0,
			dadosAdicionais: {},
			form: {
				_controleAdicional: false,
				guarnicao: {
					departamento: '',
					cargo: '',
					validade_exame: '',
					tipo_certificado: '',
					guarnicao: ''
				},

				dados_endereco_residencial: {},
				dados_adicionais: {}
			},

			erro: {
				departamento: '',
				cargo: '',
				validade_exame: '',
				tipo_certificado: '',
				guarnicao: ''
			}
		}
	},

	mounted() {
		this.carregaDados()
	},

	methods: {
		editar(dados) {
			this.form.guarnicao.departamento = dados.departamento
			this.form.guarnicao.cargo = dados.cargo
			this.form.guarnicao.validade_exame = dados.validade_exame
			this.form.guarnicao.tipo_certificado = dados.tipo_certificado
			this.form.guarnicao.guarnicao = dados.guarnicao
			this.esta_guarnicao = dados.esta_guarnicao
			this.form._controleAdicional = dados._controleAdicional

			if (this.form._controleAdicional) {
				this.$nextTick(() => {
					this.$refs.dados_adicionais.editar(dados)
				})

				this.$nextTick(() => {
					this.$refs.endereco_residencial.editar({item: dados, tipo: 'residencial'})
				})
			}
		},

		carregaDados() {
			this._httpGet('/Departamento/get_departamento', (retorno) => {
				if (retorno._request && retorno._status) {
					this.departamentos = retorno.lista
				}
			})
		},

		validaForm() {
			let passou = true
			let obg = this._traducao('global', 'campoObrigatorio')

			this.form.guarnicao.esta_guarnicao = this.esta_guarnicao

			if (this.form.esta_guarnicao == 1) {
				if (this.form.guarnicao.guarnicao == '') {
					this.erro.guarnicao = obg
					passou = false
				} else {
					this.erro.guarnicao = ''
				}

				if (this.form.guarnicao.tipo_certificado == '') {
					this.erro.tipo_certificado = obg
					passou = false
				} else {
					this.erro.tipo_certificado = ''
				}

				if (this.form.guarnicao.validade_exame == '') {
					this.erro.validade_exame = obg
					passou = false
				} else {
					this.erro.validade_exame = ''
				}

				if (this.form.guarnicao.departamento == '') {
					this.erro.departamento = obg
					passou = false
				} else {
					this.erro.departamento = ''
				}

				if (this.form.guarnicao.cargo == '') {
					this.erro.cargo = obg
					passou = false
				} else {
					this.erro.cargo = ''
				}
			}

			if (this.form._controleAdicional) {
				this.$refs.dados_adicionais.getDados()

				if (!this.$refs.endereco_residencial.validaForm()) {
					passou = false
				}
			}

			if (passou) {
				this.$emit('dados-usuario', {form: this.form})
			}

			return passou
		},

		limpaForm() {
			;(this.form.guarnicao = {
				cargo: '',
				departamento: '',
				validade_exame: '',
				tipo_certificado: '',
				anac: '',
				guarnicao: ''
			}),
				(this.erro = {
					cargo: '',
					departamento: '',
					validade_exame: '',
					tipo_certificado: '',
					anac: '',
					guarnicao: ''
				})
		}
	}
}
</script>